import React, { useEffect, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Skeleton, Stack } from "@mui/material";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { BackButton } from "../../components/common/MainButtonComponent";
import ViewEditor from "../../components/common/editor/ViewEditor";
import RadioInline from "../../components/common/form/RadioInline";
import Radio from "../../components/common/form/Radio";
import CheckBoxInline from "../../components/common/form/CheckBoxInline";
import CheckBox from "../../components/common/form/CheckBox";
import Button from "../../components/common/form/Button";
import { routes } from "../../helper/routes";
import {
  questionTypeConstants,
  questionMCQAnswerTypeConstants,
} from "../../helper/constants";
import { AzureStorage } from "../../helper/azureStorage";
import config from "../../helper/config";
import { QuestionMetaProvider } from "../../context/assessSections/QuestionMetaContext";
import {
  ViewQuestionProvider,
  useViewQuestion,
} from "../../context/assessSections/ViewQuestionContext";
import "./AssessShared.css";
import "./QuestionLibrary.css";


// function QuestionDetailPageContent() {
//   const history = useHistory();
//   const { id } = useParams();
export default function QuestionDetailPageContent({ questionId, onBack }) {
  const loadedQuestionIdRef = useRef(null);
  const {
    question,
    questionEditorState,
    passageEditorState,
    descriptiveAnswerState,
    mcqAnswerStates,
    selectedChoices,
    attachments,
    subQuestionContentStates,
    subQuestionAnswerStates,
    loading,
    subQuestionLoading,
    error,
    detailRows,
    loadQuestionForView,
  } = useViewQuestion();

  useEffect(() => {
    if (!questionId) return;

    if (loadedQuestionIdRef.current === String(questionId)) return;

    loadedQuestionIdRef.current = String(questionId);
    loadQuestionForView(questionId);
  }, [questionId]);

  const onDownloadAttachment = async (attach) => {
    const containerName = config.storageBlobConfigs.containerName;
    const content = await AzureStorage.downloadBlob(containerName, attach);

    const url = window.URL.createObjectURL(content);
    const link = document.createElement("a");

    link.href = url;
    link.download = attach;
    link.click();

    window.URL.revokeObjectURL(url);
  };

  if (loading || subQuestionLoading) {
    return (
      <ContentWrapper>
        <div style={{ padding: 24 }}>
          <Stack spacing={2}>
            <Skeleton variant="rectangular" width="100%" height={48} />
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton key={index} variant="rectangular" width="100%" height={56} />
            ))}
          </Stack>
        </div>
      </ContentWrapper>
    );
  }

  if (error) {
    return (
      <ContentWrapper>
        <div className="alert alert-danger">{error}</div>
      </ContentWrapper>
    );
  }

  if (!question) {
    return (
      <ContentWrapper>
        <div className="text-center py-5">No question found.</div>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper>
      <section className="question-detail-page">
        <div className="question-detail-topbar">
          <BackButton label="Back" onClick={onBack} />
          {/* <BackButton
            label="Back"
            onClick={() => history.push(routes.ques_lib)}
          /> */}
          <h1>{question.title}</h1>
        </div>

        <div className="question-detail-content">
          {passageEditorState?.getCurrentContent?.().hasText() && (
            <DetailRow label="Passage">
              <ViewEditor editorState={passageEditorState} />
            </DetailRow>
          )}

          <DetailRow
            label={
              question.qtype === questionTypeConstants.SUBQUESTION.id
                ? "Main Question"
                : "Question"
            }
          >
            {questionEditorState ? (
              <ViewEditor editorState={questionEditorState} />
            ) : (
              <p>No question content available.</p>
            )}
          </DetailRow>

          {question.qtype !== questionTypeConstants.SUBQUESTION.id && (
            <DetailRow label="Model Answer">
              {question.qtype === questionTypeConstants.DESCRIPTIVE.id &&
                descriptiveAnswerState && (
                  <ViewEditor editorState={descriptiveAnswerState} />
                )}

              {question.qtype === questionTypeConstants.MCQ.id && (
                <>
                  {mcqAnswerStates.map((editorState, index) => (
                    <div className="view-questions-answer d-flex" key={index}>
                      {question?.answer_type_id ===
                        questionMCQAnswerTypeConstants.One.id ? (
                        <RadioInline className="col-md-1 d-flex">
                          <Radio
                            checked={selectedChoices[index]}
                            className="oatlib-control-accent"
                            readOnly
                          />
                        </RadioInline>
                      ) : (
                        <CheckBoxInline className="col-md-1 d-flex">
                          <CheckBox
                            checked={selectedChoices[index]}
                            className="oatlib-control-accent"
                            readOnly
                          />
                        </CheckBoxInline>
                      )}

                      <div className="RichEditor-root">
                        <ViewEditor editorState={editorState} />
                      </div>
                    </div>
                  ))}
                </>
              )}

              {question.qtype === questionTypeConstants.SUBMISSION.id && (
                <div className="RichEditor-root col-lg-8">
                  {attachments.length > 0 ? (
                    attachments.map((attach) => (
                      <div key={attach}>
                        <Button
                          className="btn btn-outline-primary primary-button mr-2"
                          btnIconStyle="flaticon-interface-3"
                          inlineStyle={{ innerWidth: "400px" }}
                          btnName={attach}
                          onClick={() => onDownloadAttachment(attach)}
                        />
                        <br />
                      </div>
                    ))
                  ) : (
                    <div>No answers uploaded!</div>
                  )}
                </div>
              )}
            </DetailRow>
          )}

          {question.qtype === questionTypeConstants.SUBQUESTION.id &&
            subQuestionAnswerStates.length === 0 && (
              <DetailRow label="Model Answer">
                {descriptiveAnswerState ? (
                  <ViewEditor editorState={descriptiveAnswerState} />
                ) : (
                  <p>No answer content available.</p>
                )}
              </DetailRow>
            )}

          {question.qtype === questionTypeConstants.SUBQUESTION.id &&
            subQuestionAnswerStates.length > 0 && (
              <>
                {subQuestionAnswerStates.map((answerState, index) => (
                  <div className="row border-bottom" key={index}>
                    <div className="col-md-6 py-2">
                      <h6 className="font-weight-bolder mb-3">
                        Sub Question
                      </h6>

                      <div className="text-dark-50 line-height-lg px-0">
                        {subQuestionContentStates[index] && (
                          <ViewEditor
                            editorState={subQuestionContentStates[index]}
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 py-2">
                      <h6 className="font-weight-bolder mb-3">Answer</h6>

                      <div className="text-dark-50 line-height-lg px-0">
                        <ViewEditor editorState={answerState} />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}

          <div className="question-detail-card row g-2 mt-4">
            {detailRows.map((item) => (
              <div className="col-12 col-md-6 col-xl-4" key={item.label}>
                <span>{item.label}</span>
                <strong>{item.value || "N/A"}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>
    </ContentWrapper>
  );
}

function DetailRow({ label, children }) {
  return (
    <div className="row mb-4">
      <h6 className="font-weight-bolder mb-3 col-md-3">{label} :</h6>
      <div className="text-dark-50 line-height-lg col-md-9">{children}</div>
    </div>
  );
}

// export default function QuestionDetailPage() {
//   return (
//     <QuestionMetaProvider>
//       <ViewQuestionProvider>
//         <QuestionDetailPageContent />
//       </ViewQuestionProvider>
//     </QuestionMetaProvider>
//   );
// }